import { PipeTransform, Pipe } from '@angular/core';
import { ElementVariant } from '../entities/element-variant.entity';
import { Element } from '../entities/element.entity';

/**
 * Extract variants for element
 */
@Pipe({ name: 'extractVariantsForElement' })
export class ExtractVariantsForElementPipe implements PipeTransform {
  transform(accesories: Element[], element: Element): ElementVariant[] {
    return (
      accesories.find((accessory) => element === accessory)?.variants || []
    );
  }
}
